import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { FLOATING_ACTION_BOTTOM_CLASS } from '../../constants/floatingActions.js';
import {
  PSE_LOGO_SRC,
  PSE_PAYMENTS_HREF,
  PSE_PAYMENTS_IS_EXTERNAL,
  PSE_PAYMENTS_LABEL,
} from '../../constants/psePayments.js';

export default function PseFloatingButton() {
  const className = `group fixed ${FLOATING_ACTION_BOTTOM_CLASS} left-4 right-auto z-50 flex h-11 w-11 max-w-[calc(100vw-2rem)] items-center justify-center gap-2.5 rounded-full border border-[#1acb12]/50 bg-brand-green p-0 text-sm font-semibold text-white shadow-[0_8px_28px_rgba(103,178,53,0.45)] ring-2 ring-black/20 transition duration-200 hover:scale-[1.03] hover:bg-brand-green-dark hover:shadow-[0_12px_32px_rgba(103,178,53,0.55)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1acb12] sm:left-8 lg:left-10 lg:h-auto lg:w-auto lg:px-5 lg:py-3`;

  const content = (
    <>
      <span className="relative h-11 w-11 shrink-0 overflow-hidden rounded-full lg:h-9 lg:w-9" aria-hidden>
        <img
          src={PSE_LOGO_SRC}
          alt=""
          className="block h-full w-full rounded-full object-cover"
          width={44}
          height={44}
          loading="eager"
          decoding="async"
        />
      </span>
      <span className="hidden leading-tight lg:block">
        <span className="block text-[10px] font-medium uppercase tracking-wider text-white/85">Pagos en línea</span>
        <span className="block">{PSE_PAYMENTS_LABEL}</span>
      </span>
      {PSE_PAYMENTS_IS_EXTERNAL ? (
        <ExternalLink
          className="hidden h-4 w-4 shrink-0 opacity-80 transition group-hover:opacity-100 lg:block"
          aria-hidden
        />
      ) : null}
    </>
  );

  if (PSE_PAYMENTS_IS_EXTERNAL) {
    return (
      <a
        href={PSE_PAYMENTS_HREF}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        aria-label={`${PSE_PAYMENTS_LABEL}: abrir portal de pagos en una nueva pestaña`}
      >
        {content}
      </a>
    );
  }

  return (
    <Link
      to={PSE_PAYMENTS_HREF}
      className={className}
      aria-label={`${PSE_PAYMENTS_LABEL}: ir a contacto para información de pagos`}
    >
      {content}
    </Link>
  );
}

